module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/edition.4213b254.svg";